import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const AuthFooter = ({ para, to, navText }) => {
  return (
    <footer>
      <Typography>
        {para}
        <Link to={to} style={{ textDecoration: 'none', color: '#99CCFF', fontWeight: 600 }}>
          {navText}
        </Link>
      </Typography>
    </footer>
  );
};

export default AuthFooter;
